import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Controls = ({ className, children }: Props) => {
    return (
        <div
            className={cn(
                "tw:bottom-0 tw:w-full tw:h-14 tw:min-h-14 tw:border-t tw:border-t-grey-light tw:flex tw:justify-end tw:p-2",
                className
            )}
        >
            {children}
        </div>
    );
};
